// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","contactInfo":"Footer_contactInfo__R51Pe","socialMedia":"Footer_socialMedia__OFUJN","copyRight":"Footer_copyRight__Hwf14"};